// QA-oct I8 — Cash dialog takes a DOLLAR amount ("10.00"), not cents.
//
// Parsing is string-based on purpose: `Number('19.99') * 100` is
// 1998.9999999999998, so any float multiplication risks charging a cent off.

const MONEY_RE = /^(\d*)(?:[.,](\d{1,2}))?$/;

/**
 * Parses a user-typed amount ("10", "10.5", "10,50") into integer cents.
 * Returns null for empty, zero, negative, >2 decimals, or non-numeric input.
 */
export function parseMoneyInputToCents(raw: string): number | null {
  const trimmed = raw.trim();
  if (trimmed === '' || trimmed.endsWith('.') || trimmed.endsWith(',')) return null;
  const match = MONEY_RE.exec(trimmed);
  if (!match) return null;
  const whole = match[1] ?? '';
  const frac = match[2] ?? '';
  if (whole === '' && frac === '') return null;
  const cents = Number(whole === '' ? '0' : whole) * 100 + Number(frac.padEnd(2, '0'));
  return Number.isSafeInteger(cents) && cents > 0 ? cents : null;
}

/** Integer cents -> "10.00" (for pre-filling the input). */
export function centsToInputValue(cents: number): string {
  const whole = Math.trunc(cents / 100);
  const frac = String(cents % 100).padStart(2, '0');
  return `${whole}.${frac}`;
}
